app.component('homeMain', {
    templateUrl: 'app/home/home_main.html',
    controller: function($location, $window, $mdSidenav, localStorageAccess, medicalUtil) {
        var $ctrl = this;
        var appData = localStorageAccess.getData( "app" );
        if(appData.userPolicy == null || appData.userPolicy == "0") {
            appData.userPolicy = "0";
            localStorageAccess.setData("app", appData);
            $location.path("/user_policy");
        };        
        $ctrl.lastRunDate = "";
        $ctrl.runCount = "0";
        $ctrl.movePage = function(path) {
            $location.path(path);
        }
        $ctrl.langChange = function(lang) {
            if(lang=="en") {
                $window.location.href = "index.php";
            }
            else {
                $window.location.href = "index.php?lang=en";
            }
        };
        $ctrl.toggleLeftMenu = function() {
            $mdSidenav('left').toggle();
        };
        $ctrl.$onInit = function() {
            if(!$location.search() === "undefined") {
                $ctrl.lang = $location.search()["lang"];
            }
            var appData = localStorageAccess.getData( "app" );
            $ctrl.lastRunDate = appData.lastRunDate;
            $ctrl.runCount = appData.runCount;
            $ctrl.home_menu_info = {
                "function" : [{
                    "type" : "eatlife",
                    "icon" : "app/common/svg/check_24px.svg",
                    "title" : "食生活チェック",
                    "description" : "これまでの食生活について、セルフチェックしてみましょう。",
                    "path" : "/eatlife_check_top",
                    "alt" : "eatlife_check",
                    "color" : "#4CAF50",
                    "link" : "0"
                },
                {
                    "type" : "balance",
                    "icon" : "app/common/svg/ic_restaurant_24px.svg",
                    "title" : "食事バランス",
                    "description" : "食事画像から、食事の栄養バランスをチェックしましょう。",
                    "path" : "/foodbalance_basiccheck",
                    "alt" : "foodbalance",
                    "color" : "#009688",
                    "link" : "0"
                },
                {
                    "type" : "medical",
                    "icon" : "app/common/svg/ic_assignment_24px.svg",
                    "title" : "健診結果",
                    "description" : "健康診断結果から医師と管理栄養士からのアドバイスを閲覧できます。",
                    "path" : "/medical_main",
                    "alt" : "medical",
                    "color" : "#00BCD4",
                    "link" : "0"
                },
                {
                    "type" : "recipe",
                    "icon" : "app/common/svg/ic_restaurant_menu_24px.svg",
                    "title" : "すこやかレシピ",
                    "description" : "健康維持に役立つ料理レシピ情報を閲覧することができます。",
                    "path" : "/recipe_main/0",
                    "alt" : "recipe",
                    "color" : "#2196F3",
                    "link" : "0"
                },
                {
                    "type" : "link",
                    "icon" : "app/common/image/hiulogo.png",
                    "title" : "北海道情報大学",
                    "description" : "北海道情報大学へのリンクです。",
                    "path" : "http://www.do-johodai.ac.jp/",
                    "color" : "#03a9f4",
                    "alt" : "hiu",
                    "link" : "1"
                },
                {
                    "type" : "link",
                    "icon" : "app/common/image/hiscfw.png",
                    "title" : "食の臨床試験",
                    "description" : "北海道情報大学健康情報科学研究センターへのリンクです。様々な食品の有効性・安全性を評価する食の評価試験を行っています。",
                    "path" : "https://healthy.do-johodai.ac.jp",
                    "color" : "#03a9f4",
                    "alt" : "foot_test",
                    "link" : "1"
                },
                {
                    "type" : "link",
                    "icon" : "app/common/image/ebetulogo.gif",
                    "title" : "江別市ホームページ（保健センター）",
                    "description" : "江別市のホームページ（保健センター）です。",
                    "path" : "http://www.city.ebetsu.hokkaido.jp/soshiki/hoken",
                    "color" : "#03a9f4",
                    "alt" : "ebetu_icon",
                    "link" : "1"
                },
                {
                    "type" : "link",
                    "icon" : "app/common/image/noastec_logo.png",
                    "title" : "ノーステック財団",
                    "description" : "ノーステック財団のホームページです。",
                    "path" : "http://www.noastec.jp/",
                    "color" : "#03a9f4",
                    "alt" : "noastec_icon",
                    "link" : "1"
                },
                {
                    "type" : "link",
                    "icon" : "app/common/image/healthydo.png",
                    "title" : "ヘルシーＤｏ",
                    "description" : "ヘルシーＤｏへのリンクです。｢ヘルシーＤｏ｣は、北海道庁が創設した健康食品(機能性食品)のブランドです。",
                    "path" : "http://www.pref.hokkaido.lg.jp/kz/sss/ks/hyouziseido.htm",
                    "color" : "#03a9f4",
                    "alt" : "healthDo",
                    "link" : "1"
                }]
            };
            $ctrl.eatlifeInfo = localStorageAccess.getData("eatlife");
            $ctrl.balanceInfo = localStorageAccess.getData("balance");
            $ctrl.medicalCount = medicalUtil.getMedicalCount();
        };
        $ctrl.changeLocation = function(path, link) {
            if( link == "0" ) {
                $location.path(path);
            }
            else {
                $window.open(path);
            }
        };
        $ctrl.goUserPolicy = function() {
            $location.path("/user_policy");
        }
    }
});

